import React, { memo } from 'react';
import { injectIntl } from 'react-intl';
import { Card, CardHeader, CardContent, Divider, Grid, Typography, LinearProgress } from '@mui/material';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import { getChartColors } from '../../../../utils/chartTheme';

const TOP_N = 5;

const TicketsByAgent = memo(function TicketsByAgent(props) {
  const { data, intl } = props;
  const colors = getChartColors();

  const sorted = [...(data || [])].sort((a, b) => (b.resolvedcount || 0) - (a.resolvedcount || 0));
  const total = sorted.reduce((sum, item) => sum + (item.resolvedcount || 0), 0);
  const top = sorted.slice(0, TOP_N);
  const others = sorted.slice(TOP_N);
  const othersCount = others.reduce((sum, item) => sum + (item.resolvedcount || 0), 0);
  const topCount = total - othersCount;
  const topPercent = total > 0 ? (topCount / total) * 100 : 0;
  const othersPercent = total > 0 ? (othersCount / total) * 100 : 0;
  const maxValue = top.length > 0 ? (top[0].resolvedcount || 0) : 0;

  return (
    <Card style={{ height: '100%' }}>
      <CardHeader
        avatar={<span className="mexx-dyn-color" style={{ '--mexx-dyn-color': colors.info, display: 'flex' }}><LeaderboardIcon /></span>}
        title={intl.formatMessage({ id: 'agentproductivity.dashboard.byagent.title', defaultMessage: 'Tickets resolvidos por agente' })} />
      <Divider />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            {top.map((item, index) => (
              <Grid
                container
                key={`agent-row-${item.userid || index}`}
                alignItems="center"
                style={{ marginBottom: 10 }}
              >
                <Grid item xs={4}>
                  <Typography variant="body2" noWrap>{index + 1}&nbsp;&nbsp;{item.name}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <LinearProgress
                    variant="determinate"
                    value={maxValue > 0 ? ((item.resolvedcount || 0) / maxValue) * 100 : 0}
                    style={{
                      height: 10,
                      borderRadius: 5,
                      backgroundColor: colors.gridLine
                    }}
                    sx={{
                      '& .MuiLinearProgress-bar': {
                        backgroundColor: colors.categorical[index % colors.categorical.length]
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Typography variant="body2" align="right">
                    {item.resolvedcount} ({total > 0 ? ((item.resolvedcount / total) * 100).toFixed(1) : 0}%)
                  </Typography>
                </Grid>
              </Grid>
            ))}
            {top.length === 0 && (
              <Typography variant="body2" color="textSecondary">
                {intl.formatMessage({ id: 'agentproductivity.dashboard.byagent.empty', defaultMessage: 'Nenhum ticket resolvido no período selecionado' })}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12} md={4}>
            <Card variant="outlined">
              <CardContent>
                <Typography variant="overline" color="textSecondary">
                  {intl.formatMessage({ id: 'agentproductivity.dashboard.byagent.others', defaultMessage: 'OUTROS AGENTES' })}
                </Typography>
                <Typography variant="h4">{others.length}</Typography>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                  {intl.formatMessage({ id: 'agentproductivity.dashboard.byagent.othersagents', defaultMessage: 'agentes' })} &middot; {othersCount} {intl.formatMessage({ id: 'agentproductivity.dashboard.byagent.tickets', defaultMessage: 'tickets' })} ({othersPercent.toFixed(1)}%)
                </Typography>
                <LinearProgress
                  variant="determinate"
                  value={topPercent}
                  style={{ height: 10, borderRadius: 5, backgroundColor: colors.gridLine }}
                  sx={{ '& .MuiLinearProgress-bar': { backgroundColor: colors.primary } }}
                />
                <Grid container justifyContent="space-between" style={{ marginTop: 6 }}>
                  <Typography variant="caption">Top {TOP_N} ({topPercent.toFixed(1)}%)</Typography>
                  <Typography variant="caption">{intl.formatMessage({ id: 'agentproductivity.dashboard.byagent.otherscaption', defaultMessage: 'Outros' })} ({othersPercent.toFixed(1)}%)</Typography>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
});

export default injectIntl(TicketsByAgent);
